import { render } from "./SubscriptionImpaya.vue?vue&type=template&id=55fb607b"
import script from "./SubscriptionImpaya.vue?vue&type=script&lang=js"
export * from "./SubscriptionImpaya.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/leadsbroker-anketa/leadsbroker-anketa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__